import { useCallback, useEffect, useState, createRef, useRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import data from './data.json'
import YearItem from 'components/YearItem'

const TimeLine = ({
  tenant,
  colorMode,
  titleText,
}: {
  titleText?: string
  tenant?: Tenant
  colorMode?: string
}) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <>
      <TextWidth>
        <h3>{titleText}</h3>
      </TextWidth>
      <Timeline className={isMobile ? 'mobile' : 'desktop'}>
        {data.map(function (item: any, itemIndex: number) {
          return (
            <YearItem
              colorMode={colorMode}
              key={itemIndex}
              year={item.year}
              logos={item.logo}
              text={item.text}
              index={itemIndex}
              total={data.length}
            ></YearItem>
          )
        }, [])}
      </Timeline>

      <TextWidth>
        <Inactive>
          <h4>
            {tenant?.lang === 'fr'
              ? 'Chaînes TV supprimées'
              : 'Eingestellte TV-Sender'}
          </h4>
          <div className='logo'>
            <div>
              <img src={require('../../images/splus.jpg')} alt={'Logo splus'} />
              <div className='txt'>1993–1995</div>
            </div>
          </div>
          <div className='logo'>
            <div>
              <img
                src={require('../../images/schweiz4.jpg')}
                alt={'Logo schweiz4'}
              />
              <div className='txt'>1996–1997</div>
            </div>
          </div>
          <div className='logo'>
            <div>
              <img
                src={require('../../images/hd-suisse.jpg')}
                alt={'Logo HD Suisse'}
              />
              <div className='txt'>2007–2012</div>
            </div>
          </div>

          <h4>
            {tenant?.lang === 'fr'
              ? 'Chaînes de radio supprimées'
              : 'Eingestellte Radio-Sender'}
          </h4>
          <div className='logo'>
            <div>
              <img
                src={require('../../images/radio-international.jpg')}
                alt={'Logo Schweizer Radiop International'}
              />
              <div className='txt'>1935–2004</div>
            </div>
          </div>
          <div className='logo'>
            <div>
              Radio Beromünster
              <div className='txt'>1935–2004</div>
            </div>
          </div>
          <div className='logo'>
            <div>
              Radio Basel
              <div className='txt'>&nbsp;</div>
            </div>
          </div>
          <div className='logo'>
            <div>
              Radio Bern
              <div className='txt'>&nbsp;</div>
            </div>
          </div>
          <div className='logo'>
            <div>
              Radio Zürich
              <div className='txt'>&nbsp;</div>
            </div>
          </div>
          <div className='logo'>
            <div>
              Radio Lausanne
              <div className='txt'>&nbsp;</div>
            </div>
          </div>
          <div className='logo'>
            <div>
              {tenant?.lang === 'fr' ? 'Radio Genève' : 'Radio Genf'}
              <div className='txt'>&nbsp;</div>
            </div>
          </div>
        </Inactive>
      </TextWidth>
    </>
  )
}
const Timeline = styled.div`
  color: var(--text-color);
  max-width: 668px;
  margin: 0 auto;
`

const Inactive = styled.div`
  margin-top: 4rem;
  font-size: 1.4rem;
  color: var(--text-color);

  h4 {
    margin-bottom: 0;
    text-align: left;
  }

  .logo {
    position: relative;
    display: inline-block;
    white-space: nowrap;
    margin-right: 1.5rem;
    max-height: 25px;
    text-align: left;
    img {
      max-width: 45px;
      margin-right: 0.5rem;
      max-height: 25px;
      margin-bottom: 0;
      padding-bottom: 0;
    }
    .txt {
      margin: 0;
      padding: 0;
      font-size: 1.2rem;
      line-height: 1rem;
    }
  }
`

export default TimeLine
